
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","image-rendering":"optimizeQuality","fill-rule":"evenodd","clip-rule":"evenodd","viewBox":"0 0 128 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fefffe","d":"M-.5-.5h128v40H-.5v-40z"}}),_c('path',{attrs:{"fill":"#db143b","d":"M-.5 39.5h128v40H-.5v-40z"}})])
          )
        }
      }
    